import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTags, loadingTags } from '../redux/selectors';
import { get_tags } from '../redux/reducers';
import { Loader2 } from 'lucide-react';
import TagList from './tag-list';

const EditBulkMealTags = () => {
  const tags = useSelector(getTags);
  const loading = useSelector(loadingTags);
  const dispatch = useDispatch();
  const [openCategory, setOpenCategory] = useState(null);

  useEffect(() => {
    dispatch(get_tags());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="grid place-items-center h-screen">
        <Loader2 className="animate-spin" color="#549a9a" />
      </div>
    );
  }
  return (
    <div className="p-4 space-y-4">
      <h1 className="text-xl font-semibold">Edit Meal Tags</h1>
      {tags?.map((group, index) => {
        const isOpen = openCategory === group.category;
        return (
          <div key={index} className="rounded-lg border">
            <div
              className="flex justify-between p-4 cursor-pointer"
              onClick={() => setOpenCategory(isOpen ? null : group.category)}
            >
              <h2 className="font-semibold text-black">{group.category}</h2>

              <span>{isOpen ? '-' : '+'}</span>
            </div>

            {isOpen && (
              <div className="p-4 border-t">
                <TagList tags={group.tags} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default EditBulkMealTags;
